import React, { useContext } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { THEME_UPDATE_MESSAGE, ThemeNo } from "../../../../constant";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { TostMessage } from "../../../utils";
import InquiryContext from "../../../context/InquiryContext/InquiryContext";
import {
  InquiryThemeOneReset,
  InquiryThemeTwoReset,
} from "./InquiryStyleFunction";
import { putUpdateInquiry } from "../apis/InquiryApi/InquiryApi";
import InquiryThemeOne from "./InquiryThemeOne";
import InquiryTheme1 from "../ScreenShorts/Inquiry/InquiryTheme1.png";
import InquiryTheme2 from "../ScreenShorts/Inquiry/InquiryTheme2.png";
import ThemeImageShow from "../../../common/ThemeImageShow";
import InquiryThemeTwo from "./InquiryThemeTwo";

const SettingInquiryParentPopup = (props) => {
  const {
    isEdit,
    setSettingFormData,
    setBackImageToggle,
    setBoxSection,
    setIsBackgroundColor,
    id,
    theme,
    setTheme,
    imgShow,
    setImgShow,
  } = useContext(InquiryContext);
  const { handleSubmitSetting, handleChangeSettings, imageUpload } = props;
  const { setLoaderShow } = useContext(LoaderContext);

  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        inquiryId: id,
      };
      const { data } = await putUpdateInquiry(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };
  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = InquiryThemeOneReset;
    } else if (theme === ThemeNo.ThemeTwo) {
      setStyle = InquiryThemeTwoReset;
    } else {
      setStyle = InquiryThemeOneReset;
    }
    setSettingFormData({ ...setStyle });
    setBackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };
  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: InquiryTheme1,
    2: InquiryTheme2,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === ThemeNo.ThemeOne && (
                <InquiryThemeOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === ThemeNo.ThemeTwo && (
                <InquiryThemeTwo
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingInquiryParentPopup;
